




































































































































































































































































































































































































import { Component, Prop, Vue, Mixins, Watch, Emit } from 'vue-property-decorator';
import multiselect from 'vue-multiselect';
import Combobox from '../../core/components/Combobox.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableGeojson from '../../core/components/TableGeojson.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import InputFile from '../../core/components/InputFile.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import AlertBox from '../../core/components/AlertBox.vue';
import Input from '../../core/components/Input.vue';
import Button from '../../core/components/Button.vue';
import ModalMapPatchPolicy from './ModalMapPatchPolicy.vue';
import ModalNewPolicy from './ModalNewPolicy.vue';
// import  Input  from '../../core/components/Input.vue';

import {
    // AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
    // StoreHelper,
    // NotificationStoreHelper
} from '../../core/mixins';
import {
    geoJsonToTableFormat
} from '../../core/utils';
import { InsuranceServices } from '../api/InsuranceServices';
import PlusEyeButtons from '../../core/components/PlusEyeButtons.vue';
import moment from 'moment';

@Component({
    components: {
        // multiselect,
        Input,
        InputFile,
        Combobox,
        Button,
        SimpleTable,
        TableGeojson,
        TableArrows,
        SimpleMap,
        ModalMapPatchPolicy,
        ModalNewPolicy,
        PlusEyeButtons
    }
})
export default class ModalNewHarvest extends Mixins(NotificationStoreHelper, CompanyStoreHelper, RootStoreHelper) {
    @Prop() visible: boolean;
    @Prop({default: -1}) sowingId: number;
    @Prop({default: false}) isSowing: boolean;
    @Prop() policiesList: any;
    @Prop() policyToSelect: any;
    @Prop() patchData: any;
    modalTitle: string = 'Alta Chacra';
    submitLabelForHarvest: string = 'Agregar chacras a Poliza';
    submitLabelForSowing: string = 'Agregar chacras a Siembra actual';
    errorSelectGeojsonRanch: string = '';
    errorMsg: string = '';
    loadingMap: boolean = false;
    sowingSelectedRV: boolean = false;
    sowingSelected: any = null;
    harvestSelectedRV: boolean = false;
    harvestSelected: any = null;
    policySelectedRV: boolean = false;
    visibleMap: boolean = false;
    visibleSowingMap: boolean = false;
    visibleHarvestMap: boolean = false;
    visibleGeojsonMap: boolean = false;
    visiblePolicy: boolean = false;
    policyToPatch: null | object = null;
    policySelected: any = null;

    pendingSowings: boolean = false;
    pendingHarvests: boolean = false;
    fileContent: any = null;
    fileLoaded: boolean = false;
    pendingGeojsonItems: boolean = false;
    columnFileRV: boolean = false;
    fileOptions: Array<object> = [];
    columnFileSelected: any = null;
    polygonsToPreview: any = [];

    //desde siembra
    sowingOptions: Array<object> = [];
    selectedSowings: Array<object> = [];
    pendingSowingOptions: boolean = false;
    itemsSowing: Array<object> = [];
    headersSowing: Array<object> = [];

    //cosechas anteriores
    selectedHarvests: Array<object> = [];
    harvestsOptions: Array<object> = [];
    pendingHarvestOptions: boolean = false;
    itemsHarvest: Array<object> = [];
    headersHarvest: Array<object> = [];
    noItemsHeaders: Array<object> = [
        {
            text: 'Nombre',
            align: 'left',
            value: ''
        }
    ];

    //geojson
    itemsGeoJson: Array<object> = [];
    selectedGeojsonItems: Array<object> = [];
    headersGeoJson: Array<object> = [];

    //polígonos seleccionados
    itemsPoligonsSelected: Array<object> = [];

    headersTables: Array<object> = [
        {
            text: 'ID',
            align: 'left',
            value: 'id'
        },
        {
            text: 'Nombre',
            align: 'left',
            value: 'name'
        },
        {
            text: 'Fuente',
            align: 'left',
            value: 'source'
        }
    ];

    fileSelected: any = null;

    searchSelectedPolygons: string = '';
    crsFile: object = {};

    @Watch('policyToSelect')
    observableWhenPolicyWasAddedToList(newPolicy) {
        if (newPolicy !== null) {
            this.updatePolicySelected(newPolicy);
        }
    }

    updatesearchSelectedPolygons(value) {
        this.searchSelectedPolygons = value;
    }

    visibilitySowingMap(value) {
        this.visibleSowingMap = value;
    }

    visibilityHarvestMap(value) {
        this.visibleHarvestMap = value;
    }

    visibilityGeojsonMap(value) {
        this.visibleGeojsonMap = value;
    }

    visibilityMap(value) {
        this.visibleMap = value;
    }
    visibilityPolicyModal(value) {
        this.visiblePolicy = value;
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: 2000
        });
        this.closeModal();
    }

    doNothing(){
        //console.log("test")
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    updateSowingSelected(value) {
        this.sowingSelected = value;

        if (value !== null) {
            this.setSowings([]);
            this.loadingSowings(true);
            this.getPolygons(this.sowingSelected['id'], 1);
        }
    }
    updateSowingSelectedRV(value) {
        this.sowingSelectedRV = value;
    }
    updateHarvestSelected(value) {
        this.harvestSelected = value;

        if (value !== null) {
            this.setHarvests([]);
            this.loadingHarvests(true);
            this.getPolygons(this.harvestSelected['id'], 0);
        }
    }
    updateHarvestSelectedRV(value) {
        this.harvestSelectedRV = value;
    }
    updatePolicySelected(value) {
        this.policySelected = value;
    }
    updatePolicyRV(value) {
        this.policySelectedRV = value;
    }
    updateColumnFileSelected(value) {
        this.columnFileSelected = value;
    }
    updateColumnFileSelectedRV(value) {
        this.columnFileRV = value;
    }

    getPolygons(id, source) {
        InsuranceServices.getPrevPolygons(id, source)
            .then(res => {
                res = geoJsonToTableFormat(res);
                if (source == 0) {
                    this.headersHarvest = res['headers'];
                    this.setHarvests(this.setItemsHarvestAndSowing(res['items'], 'harvest'));
                } else {
                    this.headersSowing = res['headers'];
                    this.setSowings(this.setItemsHarvestAndSowing(res['items'], 'sowing'));
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status !== 200) {
                    this.loadingSowings(false);
                    this.loadingHarvests(false);
                }
            });
    }

    setItemsHarvestAndSowing(items, from) {
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            this.$set(item, 'from', from);
        }
        return items;
    }

    viewPoligonsOnMap(polygonsToView) {
        let geoJsonToPreview = {
            features: polygonsToView,
            type: 'FeatureCollection'
        };
        this.polygonsToPreview = geoJsonToPreview;
    }

    selectRanchsFromGeojson(selectRanchsFromGeojson) {
        // console.log('selectRanchsFromGeojson', selectRanchsFromGeojson);
        /* parse ranchs selected from geojson */
        let ranchsToSelect: any = [];
        for (let index = 0; index < selectRanchsFromGeojson.length; index++) {
            const geoJsonRanch = selectRanchsFromGeojson[index];
            let selectedColumnByUser = this.columnFileSelected == null ? 'nombre' : this.columnFileSelected['value'];

            let ranchToSelect = {
                geometry: geoJsonRanch['geometry'],
                from: 'GeoJson',
                properties: {
                    customId: geoJsonRanch['properties']['customId'],
                    id: geoJsonRanch['properties']['customId'],
                    name: geoJsonRanch['properties'][selectedColumnByUser],
                    source: 'GeoJson'
                },
                type: 'Feature'
            };

            ranchsToSelect.push(ranchToSelect);
        }
        this.selectRanchs(ranchsToSelect);
    }

    selectRanchs(itemsToAdd) {
        //  this.headersPoligonsSelected = [];
        // let items = addItemsToListIfAreNotAdded(this.itemsPoligonsSelected, itemsToAdd, 'customId');
        let features = {
            features: itemsToAdd,
            type: 'FeatureCollection'
        };
        
        itemsToAdd = geoJsonToTableFormat(features);
        for (let index = 0; index < itemsToAdd['items'].length; index++) {
            const itemToAdd = itemsToAdd['items'][index];
            let indexIdInList = this.itemsPoligonsSelected.findIndex(
                item => item['properties']['id'] === itemToAdd['properties']['id']
            );

            if (indexIdInList == -1) {
                this.itemsPoligonsSelected.push(itemToAdd);
            }
        }
        // this.headersPoligonsSelected = itemsToAdd['headers'];
    }

    removeSelectedPoligon(indexToRemove) {
        this.itemsPoligonsSelected.splice(indexToRemove, 1);
    }

    get enabledAddGeojsonRanch() {
        if (this.selectedGeojsonItems.length == 0) {
            this.errorSelectGeojsonRanch = 'No seleccionó ningun polígono';
            return false;
        }
        if (this.columnFileSelected == null) {
            this.errorSelectGeojsonRanch = 'Debe seleccionar una columna';
            return false;
        }
        return true;
    }

    get getHarvestId() {
        if (this.patchData && this.patchData['harvest'] !== null) {
            return this.patchData['harvest']['id'];
        }
    }

    get formIsValid() {
        this.setErrorForm('');
        if (!this.isSowing && this.policySelected == null) {
            this.setErrorForm('No fue seleccionada ninguna póliza');
            return false;
        }
        if (this.itemsPoligonsSelected.length == 0) {
            this.setErrorForm('No fue seleccionado ningun polígono');
            return false;
        }
        if (this.fileContent !== null && this.columnFileSelected == null) {
            this.setErrorForm('Falta seleccionar la columna del archivo');
            return false;
        }
        return true;
    }

    get fileWasUploaded() {
        return this.fileContent !== null ? true : false;
    }

    get existsSelectedSowings() {
        return this.selectedSowings.length > 0 ? true : false;
    }

    get existsSowingItems() {
        return this.itemsSowing.length > 0 ? true : false;
    }

    get enablePreviewSowing() {
        return this.existsSelectedSowings || this.existsSowingItems;
    }

    get existsSelectedHarvests() {
        return this.selectedHarvests.length > 0 ? true : false;
    }

    get existsHarvestsItems() {
        return this.itemsHarvest.length > 0 ? true : false;
    }

    get enablePreviewHarvest() {
        return this.existsSelectedHarvests || this.existsHarvestsItems;
    }

    get existsSelectedPolygons() {
        return this.itemsPoligonsSelected.length > 0 ? true : false;
    }

    get enablePreviewSelectedPolygons() {
        return this.existsSelectedPolygons;
    }

    get enablePreviewGeojson() {
        return this.itemsGeoJson.length > 0 ? true : false;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    getData() {
        // let harvestsIds = getIdsFromList()
        let form_data = new FormData();
        form_data.append('harvest_ranches', this.getRanchIdsByType(0));
        form_data.append('sowing_ranches', this.getRanchIdsByType(1));

        let getPolygonsFromGeojson = this.itemsPoligonsSelected.filter(
            item => item['properties']['source'] === 'GeoJson'
        );
        if (getPolygonsFromGeojson.length > 0) {
            let geoJson = {
                features: getPolygonsFromGeojson,
                type: 'FeatureCollection',
                crs: this.crsFile
            };
            let file = new Blob([JSON.stringify(geoJson)]);
            form_data.append('file', file);
        }
        return form_data;
    }

    getRanchIdsByType(type): string {
        let source = type == 0 ? 'harvest' : 'sowing';
        let ids: any = [];
        let filteredItmems = this.itemsPoligonsSelected.filter(item => item['from'] === source);
        // console.log('filteredItmems', filteredItmems);
        for (let index = 0; index < filteredItmems.length; index++) {
            const ranch = filteredItmems[index];
            ids.push(ranch['properties']['id']);
        }
        return ids.toString();
    }

    uploadFile() {
        this.fileOptions = [];
        this.updateColumnFileSelected(null);
        this.pendingGeojsonItems = true;
        let reader = new FileReader();
        let self = this;
        this.fileContent = null;
        this.fileLoaded = false;
        this.fileContent = this.fileSelected[0];
        reader.readAsText(this.fileSelected[0]);
        reader.onload = (e: any) => {
          self.fileLoaded = true;
          let lines = e.target.result;
          let newArr = JSON.parse(lines);

          let crs = {};
          if(newArr && newArr['crs']) {
            crs = newArr['crs'];
          }
          this.crsFile = crs;

          let items = geoJsonToTableFormat(newArr);
          self.itemsGeoJson = items['items'];
          self.headersGeoJson = items['headers'];
          self.fileOptions = items['headers'];
        };
    }

    @Emit()
    closeModal() {}

    created() {
        this.getHarvestsAndSowings();
    }

    mounted() {}

    updateSelectedHarvests(items) {
        this.selectedHarvests = items;
    }
    updateSelectedSowings(items) {
        this.selectedSowings = items;
    }

    loadingSowings(value) {
        this.pendingSowings = value;
    }

    loadingHarvests(value) {
        this.pendingHarvests = value;
    }

    setSowings(items) {
        this.itemsSowing = [];
        this.loadingSowings(true);

        setTimeout(() => {
            this.itemsSowing = items;
            this.loadingSowings(false);
        }, 200);
    }

    setHarvests(items) {
        this.itemsHarvest = [];
        this.loadingHarvests(true);

        setTimeout(() => {
            this.itemsHarvest = items;
            this.loadingHarvests(false);
        }, 200);
    }

    loadingSowingOptions(value) {
        this.pendingSowingOptions = value;
    }

    setSowingOptions(items) {
        this.loadingSowingOptions(true);

        setTimeout(() => {
            this.sowingOptions = items;
            this.loadingSowingOptions(false);
        }, 100);
    }

    loadingHarvestsOptions(value) {
        this.pendingHarvestOptions = value;
    }

    setHarvestsOptions(items) {
        this.loadingHarvestsOptions(true);

        setTimeout(() => {
            this.harvestsOptions = items;
            this.loadingHarvestsOptions(false);
        }, 100);
    }

    getHarvestsAndSowings() {
        this.loadingSowingOptions(true);
        this.loadingHarvestsOptions(true);
        InsuranceServices.getSowingAndHarvestsByCompany(this.patchData['company']['id'])
            .then(res => {
                this.setSowingOptions(res['sowings']);
                this.setHarvestsOptions(res['harvests']);
            })
            .catch(err => {
                // console.log('getHarvestsAndSowings catch', err);
            });
    }

    submitRanchs(){
        if(!this.isSowing){
            //Cosecha - agregar chacras a poliza
            this.patchPolicyAddRanchs();
        }else{
            //Siembra - Agregar chacras a Siembra actual
            this.postAddRanchsToCurrentSowing();
        }
    }

    postAddRanchsToCurrentSowing() {
        this.showLoadingDialog('Agregando chacras a Siembra actual...');
        let self = this;
        InsuranceServices.addRanchsToSowing(this.sowingId, this.getData())
            .then(res => {
                self.showSuccessLoadingDialog(res, 'Chacras agregadas con éxito');
                self.$emit('update-detail');
            })
            .catch(err => {
                self.showCatchLoadingDialog(err, 'No se pudieron agregar las chacras');
            });
    }
    patchPolicyAddRanchs() {
        let self = this;
        this.showLoadingDialog('Agregando chacras a poliza...');
        InsuranceServices.patchPolicyAddRanches(this.policySelected['id'], this.getData())
            .then(res => {
                self.showSuccessLoadingDialog(res, 'Poliza modificada con éxito');
                self.$emit('update-detail');
            })
            .catch(err => {
                self.showCatchLoadingDialog(err, 'No se pudo modificar la poliza');
            });
    }

    addSelectedRanchsFromMap(selectedRanchsFromMap, from) {
        let selectedRanchs = this.setItemsHarvestAndSowing(selectedRanchsFromMap, from);
        this.selectRanchs(selectedRanchs);
    }

    excludeSelectedPoligonHand(item) {
        this.ranchToExclude(item['properties']['id']);
    }

    ranchToExclude(ranchIdToExclude: number) {
        let indexIdInList = this.itemsPoligonsSelected.findIndex(item => item['properties']['id'] === ranchIdToExclude);
        if (indexIdInList !== -1) {
            this.removeSelectedPoligon(indexIdInList);
        }
    }

    viewGeojsonPolygons() {
        if (this.selectedGeojsonItems.length > 0) {
            this.viewPoligonsOnMap(this.selectedGeojsonItems);
        } else {
            this.viewPoligonsOnMap(this.itemsGeoJson);
        }
        this.visibleGeojsonMap = true;
    }

    viewSowingPolygons(from) {
        let sowingPolygons = this.existsSelectedSowings ? this.selectedSowings : this.itemsSowing;

        this.viewPoligonsOnMap(sowingPolygons);
        this.visibleSowingMap = true;
    }

    viewHarvestPolygons(from) {
        let harvestPolygons = this.existsSelectedHarvests ? this.selectedHarvests : this.itemsHarvest;

        this.viewPoligonsOnMap(harvestPolygons);
        this.visibleHarvestMap = true
        
    }

    viewSelectedPolygons() {
        this.viewPoligonsOnMap(this.itemsPoligonsSelected);
        this.visibleSowingMap = true;
    }

    updateGeojsonSelectedRanchs(items) {
        this.selectedGeojsonItems = items;
    }

    clearFile() {
        this.fileSelected = null;
        this.fileOptions = [];
        this.itemsGeoJson = [];
        this.headersGeoJson = [];
        this.fileContent = null;
        this.columnFileSelected = null;
    }

    addNewPolicyToList(newPolicy) {
        this.$emit('update-policies-list', newPolicy);
    }

    updatePolicyInList(updatedPolicy) {
        this.$emit('update-policy-in-list', updatedPolicy);
    }

    removePolicyFromList(policyIdToDelete) {
        this.$emit('remove-policy-from-list', policyIdToDelete);
    }

    selectPolicy(value) {
        this.updatePolicySelected(value);
    }

    selectedFile(file) {
        this.fileSelected = file;
        let existFile = this.fileSelected !== null && this.fileSelected.length > 0;
        if (existFile) {
            this.uploadFile();
        }else{
            this.clearFile();
        }
    }

    createNewPolicy() {
        this.policyToPatch = null;
        this.visibilityPolicyModal(true);
    }

    modifyPolicy() {
        this.policyToPatch = this.policySelected;
        this.visibilityPolicyModal(true);
    }
}
